<div class="details-container">
  @if (loading) {
    <div class="loading-state">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Loading explanation...</p>
    </div>
  }

  @if (error && !loading) {
    <div class="error-state">
      <mat-icon color="warn">info</mat-icon>
      <p>{{ error }}</p>
      <!-- Show "View Task" button if there's an active ingestion task -->
      @if (existingTaskId) {
        <button mat-raised-button color="accent" (click)="viewTask()">
          <mat-icon>assignment</mat-icon>
          View Task
        </button>
      }
      <!-- Show "Re-ingest" button if no active task -->
      @if (!existingTaskId) {
        <button mat-raised-button color="primary" (click)="generateExplanation()">
          <mat-icon>refresh</mat-icon>
          Re-ingest Page with Explanation
        </button>
      }
      @if (!existingTaskId) {
        <p class="hint">Re-ingests this page with AI explanation generation enabled (2-4 minutes)</p>
      }
    </div>
  }
  @if (explanationHtml && !loading && !error) {
    <div class="explanation-content markdown-renderer-container" [innerHTML]="explanationHtml"></div>
  }
  @if (activePage?.getModelStamp(); as stamp) {
    @if (stamp.getModelName()) {
      <div class="model-metadata">
        Model: {{ stamp.getModelName() }}
        @if (stamp.getProfileId()) {
          ({{ stamp.getProfileId() }})
        }
        @if (stamp.getCreatedTime()) {
          | {{ modelStampDate | date: 'yyyy/MM/dd HH:mm' }}
        }
      </div>
    }
  }
</div>
